module.exports = __webpack_public_path__ + "static/media/Angel Wong.a0bc2e16.png";